import { style } from "typestyle";
import { MARGINS_PX } from "../../../constants";

// function transitionProperties(
//     speed: string,
//     porperties: string[]
// ): string {
//     return porperties.map(porpertyName => `${porpertyName} ${speed} linear`).join(', ');
// }

export const tabButtonpadClassName = style({
    display: 'block',
    textAlign: 'center',
    margin: `-${MARGINS_PX / 2}px 0`,
});

export const tabButtonClassName = style({
    margin: `${MARGINS_PX / 2}px`,
    width: '154px',
    // paddingLeft: `${MARGINS_PX * 2}px`,
    // paddingRight: `${MARGINS_PX * 2}px`
});
